import React from 'react'
import './style.css'
function SkeletonUdemy() {
  return (
    <div className=' items-center justify-center flex align-middle w-full mx-auto my-24'>

    <div className="custom-loader"></div>
   
   
    </div>
  )
}

export default SkeletonUdemy
